const DETACHED_WINDOW_ROOT_ID = "grain-detached-window-root";

function buildWindowFeatures({ width = 1160, height = 860 } = {}) {
  const left = Number.isFinite(Number(window.screenX))
    ? Math.max(Number(window.screenX) + 56, 0)
    : 80;
  const top = Number.isFinite(Number(window.screenY))
    ? Math.max(Number(window.screenY) + 48, 0)
    : 64;

  return [
    "popup=yes",
    `width=${Math.round(width)}`,
    `height=${Math.round(height)}`,
    `left=${Math.round(left)}`,
    `top=${Math.round(top)}`,
    "resizable=yes",
    "scrollbars=no",
  ].join(",");
}

function cloneHeadNode(sourceNode, targetDocument) {
  const tagName = sourceNode?.tagName?.toLowerCase?.() || "";

  if (tagName === "style") {
    const styleElement = targetDocument.createElement("style");
    styleElement.textContent = sourceNode.textContent || "";
    return styleElement;
  }

  if (tagName === "link" && sourceNode.getAttribute("rel") === "stylesheet") {
    return sourceNode.cloneNode(true);
  }

  return null;
}

function prepareDetachedDocument(popupWindow, title) {
  const sourceDocument = window.document;
  const targetDocument = popupWindow.document;

  targetDocument.open();
  targetDocument.write("<!DOCTYPE html><html><head></head><body></body></html>");
  targetDocument.close();
  targetDocument.title = title;
  targetDocument.documentElement.lang = sourceDocument.documentElement.lang || "fr";

  const charsetMeta = targetDocument.createElement("meta");
  charsetMeta.setAttribute("charset", "utf-8");
  targetDocument.head.appendChild(charsetMeta);

  const viewportMeta = targetDocument.createElement("meta");
  viewportMeta.setAttribute("name", "viewport");
  viewportMeta.setAttribute("content", "width=device-width, initial-scale=1");
  targetDocument.head.appendChild(viewportMeta);

  Array.from(sourceDocument.head.children).forEach((childNode) => {
    const clonedNode = cloneHeadNode(childNode, targetDocument);
    if (clonedNode) {
      targetDocument.head.appendChild(clonedNode);
    }
  });

  targetDocument.body.style.margin = "0";
  targetDocument.body.style.minHeight = "100vh";
  targetDocument.body.style.overflow = "hidden";
  targetDocument.body.style.background = "linear-gradient(180deg, rgba(255,255,255,0.992), rgba(248,250,252,0.98))";

  const mountNode = targetDocument.createElement("div");
  mountNode.id = DETACHED_WINDOW_ROOT_ID;
  mountNode.style.minHeight = "100vh";
  targetDocument.body.appendChild(mountNode);

  return mountNode;
}

export function openDetachedWindow({
  height = 860,
  name = "grain-detached-window",
  title = "Fenetre detachee",
  width = 1160,
} = {}) {
  if (typeof window === "undefined") {
    return null;
  }

  const popupWindow = window.open("", name, buildWindowFeatures({ height, width }));
  if (!popupWindow) {
    return null;
  }

  const mountNode = prepareDetachedDocument(popupWindow, title);
  popupWindow.focus?.();

  return {
    mountNode,
    popupWindow,
  };
}

export function updateDetachedWindowTitle(detachedWindow, title) {
  const popupWindow = detachedWindow?.popupWindow || detachedWindow;
  if (!popupWindow || popupWindow.closed) {
    return;
  }

  popupWindow.document.title = title;
}

/** Sans dimensions ni option popup : le navigateur ouvre un onglet ordinaire. */
export function openDetachedTab({ title }) {
  const popupWindow = window.open("", "_blank");
  if (!popupWindow) return null;
  popupWindow.opener = null;
  return { popupWindow, mountNode: prepareDetachedDocument(popupWindow, title) };
}

export function closeDetachedWindow(detachedWindow) {
  const popupWindow = detachedWindow?.popupWindow || detachedWindow;
  if (popupWindow && !popupWindow.closed) {
    popupWindow.close();
  }
}
